export default "__VITE_ASSET__BhTCcE4N__"